// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-3d065c56]{color:#fff;display:grid;grid-template-columns:1fr 50px;grid-template-rows:auto}.close_icon[data-v-3d065c56]{transition:text-shadow .1s ease-in-out,transform .2s ease-in-out}.close_icon[data-v-3d065c56]:hover{text-shadow:1px 2px 3px #000;cursor:pointer!important}.app_model_content[data-v-3d065c56]{padding:8px;max-height:60vh;overflow:auto;border-radius:3px;border-bottom:1px solid #ddd;border-top:3px solid #fff}", ""]);
// Exports
module.exports = exports;
